import { Typography, Pagination, Select, Spin, Row, Empty, Tooltip, notification, Popconfirm, Button, Badge } from 'antd';
import React, { useEffect, useState } from 'react';
import useLogout from '../../hooks/useLogout';
import { useGetSupportingArticles, useGetSupportingArticlesFilters } from '../../hooks/useSupportingArticle';
import useStudios, { useListingStudios } from '../../hooks/useStudios';
import PlusIconActionButton from '../../components/PlusIconActionButton';
import arrowLeft from '../../../src/assets/images/arrowLeft.png';
import { useNavigate } from 'react-router-dom';
import { DeleteOutlined, QuestionCircleOutlined, EditOutlined, FilterFilled } from '@ant-design/icons';
import { useDeleteSupportingArticle } from '../../hooks/useSupportingArticle';
import EditSupportingArticles from './EditSupportingArticlesModal';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import SupportingArticlesFilters from './SupportingArticlesFilters';

import for_kids from '../../../src/assets/images/gender_kids.png';
import for_female from '../../../src/assets/images/gender_female.png';
import for_male from '../../../src/assets/images/gender_male.png';
import for_unisex from '../../../src/assets/images/gender_unisex.png';

const AllSupportingArticles = () => {
    const pageSize = 30;
    const [current, setCurrent] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    const [allArticles, setAllArticles] = useState([]);
    const [studioId, setStudioId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [isSelectingFilters, setSelectingFilters] = useState(false);
    const [localFiltersExisted, setLocalFiltersExisted] = useState({});
    const [localFiltersApplied, setLocalFiltersApplied] = useState({});
    const [pageNum, setPageNum] = useState(1);
    const [filtersList, setFiltersList] = useState([]);
    const [selectedStudioTags, setSelectedStudioTags] = useState([]);
    const [filterCount, setFilterCount] = useState(0);

    const navigate = useNavigate();
    const [openModal, setOpen] = useState(true);
    const [api, contextHolder] = notification.useNotification();

    const onGetArticlesSuccess = resp => {
        setAllArticles(resp?.data?.data);
        setTotalCount(resp?.data?.totalCount);
    };

    const { isLoading, isError, mutate: refetchSupportingArticles } = useGetSupportingArticles(onGetArticlesSuccess);
    const { mutate: getSupportingArticlesFilters } = useGetSupportingArticlesFilters(onGetFArticleFiltersSuccess);
    const { mutate: DeleteSupportingArticle } = useDeleteSupportingArticle(DeleteSupportingArticleSuccess);

    const transform = data => {
        return data.map(item => {
            return {
                name: item?.name,
                id: item._id,
            };
        });
    };
    const StudioListError = err => {
        if (err?.response?.status === 401) logout();
    };
    // const { data: studios } = useStudios(null, transform);
    const { data: studioList } = useListingStudios(null, transform, StudioListError);

    const { logout } = useLogout();

    useEffect(() => {
        refetchSupportingArticles({ pageSize, pageNum: current, studioId, filters: JSON.stringify(localFiltersApplied) });
    }, []);

    useEffect(() => {
        studioId && getSupportingArticlesFilters({ studioId });
    }, [studioId]);

    const onChange = pageNum => {
        setCurrent(pageNum);
        refetchSupportingArticles({ pageSize, pageNum, studioId, filters: JSON.stringify(localFiltersApplied) });
    };

    if (isError) {
        logout();
    }

    const onStudioChange = studioId => {
        setStudioId(studioId);
        setCurrent(1);
        if (studioId) {
            refetchSupportingArticles({ pageSize, studioId, filters: JSON.stringify(localFiltersApplied) });
        } else {
            refetchSupportingArticles({ pageSize, studioId });
            setLocalFiltersApplied({});
        }
    };

    function onGetFArticleFiltersSuccess(resp) {
        setFiltersList(resp?.data);
    }
 
    function onUpdateArticleSuccess(resp) {
        if (resp && resp.status === 200) {
            notification.success({
                message: `Successful!`,
                description: 'Successfully updated!',
                placement: 'topRight',
            });
            refetchSupportingArticles();
            setShowEditModal(false);
        }
    }

    function DeleteSupportingArticleSuccess(resp) {
        api.success({
            message: 'Supporting Article deleted successfully',
        });
        refetchSupportingArticles({ pageSize, pageNum: current, studioId });
    }

    const handleEditing = article => {
        setSelectedStudioTags(article);
        setShowEditModal(true);
    };

    const handleSelectFilters = () => {
        studioId && setSelectingFilters(true);
    };

    const handleApplyFilters = () => {
        setFilterCount(Object.keys(localFiltersApplied).length);
        setLocalFiltersExisted(localFiltersApplied);
        setPageNum(1);
        setSelectingFilters(false);
        refetchSupportingArticles({ pageSize, pageNum: 1, studioId, filters: JSON.stringify(localFiltersApplied) });
    };

    const handleCancelFilters = () => {
        setLocalFiltersApplied(localFiltersExisted);
        setSelectingFilters(false);
    };

    const handleResetFilters = () => {
        setLocalFiltersApplied({});
        setSelectingFilters(false);
        refetchSupportingArticles({ pageSize, pageNum: 1, studioId });
        setFilterCount(0);
    };
    const closeEditModal = () => {
        showEditModal(false);
    };
    const getImgSrc = gender => {
        const genderArr = ['for_kids', 'for_female', 'for_male', 'for_unisex'];
        const genderVariableArr = [for_kids, for_female, for_male, for_unisex];

        let genderIndx = genderArr.findIndex(itm => itm.includes(`for_${gender}`));
        if (genderIndx > -1) {
            return genderVariableArr[genderIndx];
        }
    };

    return (
        <div>
            {isLoading && (
                <div className="spin-center">
                    <Spin className="spin_loader" size="large" />{' '}
                </div>
            )}

            {showEditModal && (
                <DynamicModal
                    open={showEditModal}
                    width={800}
                    closable={true}
                    close={() => setShowEditModal(false)}
                    component={
                        <EditSupportingArticles
                            selectedStudioTags={selectedStudioTags}
                            refetchSupportingArticles={() => refetchSupportingArticles({ pageSize, pageNum, studioId })}
                            closeEditModal={() => closeEditModal()}
                            onUpdateArticleSuccess={onUpdateArticleSuccess}
                        />
                    }
                />
            )}
            {isSelectingFilters && (
                <DynamicModal
                    closable={true}
                    open={isSelectingFilters}
                    close={() => {
                        handleCancelFilters();
                    }}
                    // handleSave={() => {
                    //     handleApplyFilters();
                    // }}
                    title={'Filter Supporting Article'}
                    height={'300px'}
                    width="50%"
                    style={{ width: '60%' }}
                    okText="Apply"
                    cancelText="Cancel"
                    component={
                        <SupportingArticlesFilters
                            filtersList={filtersList}
                            localFiltersApplied={localFiltersApplied}
                            setLocalFiltersApplied={setLocalFiltersApplied}
                            handleApplyFilters={handleApplyFilters}
                            handleCancelFilters={handleCancelFilters}
                            handleResetFilters={handleResetFilters}
                            studioId={studioId}
                        />
                    }
                />
            )}
            {contextHolder}
            <div className="article_header">
                <h5>All Supporting Articles: </h5>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <h5>Select Studio</h5>
                    <Select placeholder="Select a Studio" onChange={onStudioChange} className="filter_dropdown" style={{ marginRight: 0 }}>
                        <Select.Option key="none" value={null}>
                            All
                        </Select.Option>
                        {studioList?.map(el => {
                            return (
                                <Select.Option key={el.id} value={el.id}>
                                    {el?.name}
                                </Select.Option>
                            );
                        })}
                    </Select>
                    <Button type="text" style={{ padding: '2px', marginRight: '50px' }} onClick={handleSelectFilters}>
                        {filterCount ? (
                            studioId ? (
                                <Badge count={filterCount} size="small">
                                    <FilterFilled style={{ fontSize: '20px' }} />
                                </Badge>
                            ) : (
                                <Tooltip title="Select a studio">
                                    {' '}
                                    <Badge count={filterCount} size="small">
                                        <FilterFilled style={{ fontSize: '20px', color: 'darkgray' }} />
                                    </Badge>
                                </Tooltip>
                            )
                        ) : studioId ? (
                            <FilterFilled style={{ fontSize: '20px' }} />
                        ) : (
                            <Tooltip title="Select a studio">
                                <FilterFilled style={{ fontSize: '20px', color: 'darkgray' }} />
                            </Tooltip>
                        )}
                    </Button>
                </div>
            </div>
            <hr
                style={{
                    width: '100%',
                    margin: '0 20px 10px 0',
                    color: '#e8e8e8',
                }}
            />
            {allArticles.length > 0 ? (
                <>
                    <div
                        className="article_wrapper"
                        style={{
                            height: 'calc(100vh - 200px)',
                            opacity: isLoading ? 0.4 : 1,
                        }}
                    >
                        {allArticles?.map((article, index) => (
                            <div key={article._id} className="article_container">
                                <Popconfirm
                                    title="Delete the Supporting Article"
                                    description="Are you sure to delete this article?"
                                    icon={
                                        <QuestionCircleOutlined
                                            style={{
                                                color: 'red',
                                            }}
                                        />
                                    }
                                    onConfirm={() => DeleteSupportingArticle(article._id)}
                                >
                                    <Tooltip title="Delete">
                                        <div className="deleteIcon">
                                            <DeleteOutlined />
                                        </div>
                                    </Tooltip>
                                </Popconfirm>
                                <Tooltip title="Edit">
                                    <div className="editIcon">
                                        <EditOutlined onClick={() => handleEditing(article)} />
                                    </div>
                                </Tooltip>
                                {article?.productTags?.Gender && (
                                    <Tooltip title={article?.productTags?.Gender}>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                right: '5px',
                                                top: '5px',
                                                height: '18px',
                                                width: '18px',
                                                zIndex: 3,
                                                background: 'rgba(255,255,255,0.8)',
                                                borderRadius: '50%',
                                                padding: 0,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                // border: "1px solid rgba(0,0,0,0.6)",
                                                boxShadow: '1px 2px 9px -2px grey',
                                            }}
                                        >
                                            <img src={getImgSrc(article?.productTags?.Gender?.toLowerCase())} alt="" height="60%" width="60%" />
                                        </div>
                                    </Tooltip>
                                )}

                                <img alt="article_img" className="article_image" src={article?.image?.thumbPath?.url} />
                                <div className="article_info_container">
                                    <Typography
                                        className="card_subtitle"
                                        style={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            marginRight: '5px',
                                        }}
                                    >
                                        Type:
                                    </Typography>
                                    <Typography className="card_subtitle">{` ${article.type}`}</Typography>
                                </div>
                                <div className="article_info_container">
                                    <Typography
                                        className="card_subtitle"
                                        style={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            marginRight: '5px',
                                            overflow: 'clip',
                                        }}
                                    >
                                        Studio Name:
                                    </Typography>
                                    <Typography className="card_subtitle">{`${article?.studio && article?.studio[0]?.name}`}</Typography>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            height: '40px',
                        }}
                    >
                        <Pagination
                            current={current}
                            // defaultCurrent={1}
                            onChange={onChange}
                            pageSize={pageSize}
                            total={totalCount}
                            hideOnSinglePage
                            showSizeChanger={false}
                        />
                    </div>
                    <PlusIconActionButton onClick={() => navigate('/supportingArticle')} title="Add Supporting Articles" />
                </>
            ) : (
                <Empty description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} imageStyle={{ marginTop: '200px' }} />
            )}
        </div>
    );
};

export default AllSupportingArticles;
